import { Box, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import complexCarNameStyles from './ComplexCarNameStyles';
import Translation from '../../translation/Translation';

export interface IComplexCarNameProps {
  modelName: string;
  className?: string;
  testId?: string;
}

const ComplexCarName: FC<IComplexCarNameProps> = ({ modelName, className, testId }) => {
  const styles = complexCarNameStyles();

  return (
    <Box className={className} data-test={testId}>
      <Typography component="span" variant="h4" className={styles.modelName}>
        <Translation id="spc.customise.nameplatePrefix" />
      </Typography>
      <Typography component="span" variant="h4" className={styles.modelName}>
        {modelName}
      </Typography>
    </Box>
  );
};

export default ComplexCarName;
